import { passwordGrade } from '../../../../../../util/password-strength';

export class Controller {

    /** @ngInject */
    constructor(Alert, ApplicationAccountsResource, GroupsResource) {
        this.Alert = Alert;
        this.ApplicationAccountsResource = ApplicationAccountsResource;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.accounts = [];
        this.isLoading = true;

        this.isComputerApplication = this.is('computer-protection-without-ad','computer-login');
        this.isAdPasswordManagerApplication = this.is('ad-password-manager');
        this.adPasswordViewSupported = this.application.adAccountPasswordsCanBeViewed;
        this.isAdPassEditableApplication = this.application.adAccountPasswordsCanBeEdited && (this.is('computer-login') || this.is('ad-password-manager'));

        this.isAdApplication = this.isAdPassEditableApplication;
        this.numberOfColumns = 3;
        this.GroupsResource
            .getApplicationGroupAccountCredentials(this.companyId, this.groupId, this.application.id)
            .then(dto => {
                this.policy = dto.applicationPasswordPolicy;
                this.accounts = dto.appAccountPasswords.map(account => (
                {...account, 
                    passGrade: passwordGrade(account.password), 
                    searchObj: [account.username, account.user.saaspassId, account.user.displayName]
                }));
                var cantSeePassPart1=false;
                var canEditPassPart1=false;
                if(this.policy !== null) {
                	
                	cantSeePassPart1=!this.policy.adminCanSeePassword;
                	canEditPassPart1=!this.policy.adminCanSetPassword;
                    if (this.policy.userCanResetPassword && this.policy.adminCanResetPassword) {
                        this.numberOfColumns = 5;
                    } else if (this.policy.adminCanResetPassword) {
                        this.numberOfColumns = 4;
                    }
                }
                this.adminCantSeePass=cantSeePassPart1 || (this.isComputerApplication && this.isAdPassEditableApplication && !this.adPasswordViewSupported);
                this.readOnlyPass=canEditPassPart1 || (this.isComputerApplication && !this.isAdPassEditableApplication);
            })
            .finally(() => this.isLoading = false);
    }

    saveEmail(account, email) {
        const accId = account.companyUserAccountId;
        return this.ApplicationAccountsResource
            .setPasswordResetEmailForAppAccount(this.companyId, this.application.id, accId, email)
            .then(() => account.resetEmail = email)
            .then(() => this.Alert('success', 'company.manage-application.users.manage-passwords.saved'));
    }

    generatePassword(account) {
        const accId = account.companyUserAccountId;
        return this.ApplicationAccountsResource
            .generatePasswordForAppAccount(this.companyId, this.application.id, accId);
    }

    savePassword(account, password) {
        const accId = account.companyUserAccountId;
        return this.ApplicationAccountsResource
            .setPasswordForAppAccount(this.companyId, this.application.id, accId, password)
            .then(() => {
                account.password = password;
                account.passGrade = passwordGrade(password);
                this.Alert('success', 'company.manage-application.users.manage-passwords.saved');
            });
    }

    sendReset(account) {
        const accId = account.companyUserAccountId;
        this.sendingResetForAccount = account;
        this.ApplicationAccountsResource
            .sendPasswordResetEmailForAppAccount(this.companyId, this.application.id, accId)
            .then(() => this.Alert('success', 'company.manage-application.users.manage-passwords.sent'))
            .finally(() => this.sendingResetForAccount = null);
    }

    sendResetClass(account) {
        return this.sendingResetForAccount === account ? 'fa fa-sync fa-spin' : 'fa fa-envelope';
    }

    sendResetDisabled(account) {
        return !account.resetEmail || this.sendingResetForAccount === account;
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/manage-passwords/manage-passwords.controller.js